import React from 'react';
import { Button } from './styled';
import { MdLockOutline } from 'react-icons/md';

export const ButtonSend = ({ isLoading, disabled, text, onClick }) => {

  return (
    <Button disabled={disabled} onClick={onClick}>
      {disabled && <MdLockOutline />}
      {isLoading ? <span /> : text}
    </Button>
  );
}
